<div class="p-inputgroup"
  [class.min-width]="elementType === 'boolean' || elementType === 'nn'"
  formGroupName="{{ formGroupNameValue }}"
>
  <p-select *ngIf="availableFilterTypes?.length > 1"
    class="filter-type p-inputgroup-addon"
    formControlName="filterType"
    [options]="availableFilterTypes"
  ></p-select>
  <span *ngIf="availableFilterTypes?.length === 1"
        class="filter-type p-inputgroup-addon"
  >{{availableFilterTypes[0].label}}</span>

  <input *ngIf="elementType === 'string' || elementType === 'uri' || elementType === 'enum'"
    class="filter-value"
    formControlName="filterValue"
    pInputText
    placeholder="{{ placeholderValue }}"
    type="text"
  >

  <input *ngIf="elementType === 'number'" type="number"
    class="filter-value"
    formControlName="filterValue"
    pInputNumber
    min="0"
    placeholder="{{ placeholderValue }}"
    >

  <p-datepicker *ngIf="elementType === 'date'"
    class="filter-value"
    dateFormat="dd.mm.yy"
    formControlName="filterValue"
    hourFormat="24"
    [monthNavigator]="true"
    placeholder="{{ placeholderValue }}"
    [showButtonBar]="true"
    [showSeconds]="true"
    [showTime]="true"
    [yearNavigator]="true"
    [yearRange]="yearRange"
  ></p-datepicker>

  <p-select *ngIf="elementType === 'boolean' || elementType === 'nn'"
    class="filter-value"
    formControlName="filterValue"
    [options]="booleanSelectItems"
    placeholder="&nbsp;"
  ></p-select>
</div>
